//=============================================================================
// Contents   : HRDB
//              部署マスタ一覧
//              GetDepartmentList
// Author     : RV上田
// LastUpdate : 2023/1/18
// Since      : 2022/12/2
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React, { useState } from "react";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";

/* ====== Style ====== */
import { MasterTemp } from "01Pages/Template/MasterTemp";
import { useLocation, useNavigate } from "react-router-dom";
import { useProvideData } from "03CommonApiParts/use-context";
import { CFArrayFount, CFStringEncodeJP } from "03CommonApiParts/CommonFunction";
import { fileUploadS3 } from "03CommonApiParts/use-file";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ




/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 一覧テンプレート ========= */
export const GetDepartmentList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */
    const navigate = useNavigate();
    const location = useLocation();
    const apiData = useProvideData();//APIデータ取得
    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 




    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    })

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */
    /* ===登録ボタンを押した時の処理=== */
    const onClickResister = (newData, oldData, type) => {
        navigate('/master/department/register',{state:{row:null, new: newData, old: oldData, type: type}})//データを遷移先へ渡す
    }
    /* ===フォーマット取得を押した時の処理=== */
    const onClickFormat = () => {
        document.getElementById('fileUpload').click();
    };
    /* === ファイルアップロード時の処理 === */
    const handleFileSelect = async(event) => {
        /* プログレスバー表示 */
        setProgress(true);

        const file = event.target.files[0]; // ファイル情報を取得
        var fileId;

        /* リクエスト先 */
        const apiPath = '/common/getuploadurl';
        const apiPathBatch = '/master/updatebatchdepartment';

        /* リクエストデータ */
        const handlingInformation = {};
        var key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'REGISTER';

        /* キー */
        key.fileTypeCd = "batchUpdateExcelFileUploadFolder";
        key.fileName = CFStringEncodeJP(file.name, base64Swicth);
        key.cntType = CFStringEncodeJP(file.type, base64Swicth);

        /* リクエストパラメータ */
        var apiBody = {handlingInformation:handlingInformation, key:[key]};
        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, async(result) => {
            /* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                fileId = result.responseData.data.payload[0].fileId;
                /* ファイルアップロード処理開始(取得した認証付きURL,ファイルデータ,コンテンツタイプ) */
                const uploadData = {
                    fileData: file,
                    contentType: file.type,
                    signedUrl: result.responseData.data.payload[0].sgnUrl//認証付きURL
                }
                await fileUploadS3(uploadData,async(uploadResut)=>{
                    if(uploadResut.isSuccessed){
                        // 操作IDを変更
                        handlingInformation.hndId = 'UPDATE';
                        /* キー */
                        key = {};
                        key.fileTypeCd = "batchUpdateExcelFileUploadFolder";
                        key.fileId = fileId;
                        key.cntType = CFStringEncodeJP(file.type, base64Swicth);

                        /* リクエストパラメータ */
                        var apiBody = {handlingInformation:handlingInformation, key:key};

                        /* API処理開始 */
                        await apiData.getDataPost(apiPathBatch, apiBody, (result) => {
                            document.getElementById('fileUpload').value = ''
                            /* プログレスバー非表示 */
                            setProgress(false);
                            /* APIリクエスト結果を判定 */
                            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                                navigate('/common/completion', {
                                    state:{
                                        title: `部署マスタ一括編集`, 
                                        message: `${screenDisplayMessage('CMNI009')}`, //データの更新が完了しました。
                                        button:[
                                            {name: '一覧画面へ戻る', path: '/master/department/list'}
                                        ]
                                        },
                                    replace:true
                                },);
                            }else{//APIリクエスト結果 = 異常
                                /* プログレスバー非表示 */
                                setProgress(false);
                                if(result.responseData.data.error.code === '200002'){
                                    /* エラー表示内容編集 */
                                    const itemNameList = [
                                        { id:'dptCd',          name:'部署コード'},
                                        { id:'dptHqName',    name:'本部'},
                                        { id:'dptHqEngName',      name:'本部_英名'},
                                        { id:'dptHqOrd',   name:'本部順'},
                                        { id:'dptPartName',   name:'部'},
                                        { id:'dptPartEngName',     name:'部_英名'},
                                        { id:'dptPartOrd',  name:'部順'},
                                        { id:'dptRomName',    name:'室'},
                                        { id:'dptRomEngName',      name:'室_英名'},
                                        { id:'dptRomOrd',   name:'室順'},
                                        { id:'dptGpName',      name:'G'},
                                        { id:'dptGpEngName',          name:'G_英名'},
                                        { id:'dptGpOrd',       name:'G順'},
                                        { id:'dptAbrName',        name:'部署略名'},
                                        { id:'upperDptCd',           name:'上位部署コード'},
                                        { id:'dptLevel',         name:'部署レベル'},
                                        { id:'lboCstClasfCd', name:'人件費区分'},//APIの仕様上Codeでレスポンスするが、画面上では人件費区分名と表示
                                        { id:'projSgmtCd',       name:'事業セグメント'},
                                        { id:'partWithinCmmKbjCd',     name:'部内共通(KBJ)コード'},
                                        { id:'salesMnaExpePjCd',    name:'販管費PJコード'},
                                        { id:'lboCstPjCd',    name:'人件費PJコード'},
                                        { id:'mnaEmpNmb',      name:'所属長'},
                                        { id:'dptChangeCont',      name:'変更内容'},//後で消す
                                        { id:'apply_start_date',      name:'適用日'}//後で消す
                                    ];

                                    const validationList = [
                                        { id:'requiered', eng:'field is required', jp:'必須です'},
                                        { id:'number', eng:'must be  (.{1,3}) characters', jp:'桁で入力してください'},
                                        { id:'numberBetween', eng:'must be between  (.) and (.{1,3}) characters', jp:'桁で入力してください'},
                                        { id:'afterToday', eng:'must be equal or after today', jp:'今日以降の日付で入力してください'},
                                        { id:'invalid', eng:'invalid', jp:'正しいフォーマット入力してください'},
                                        { id:'string', eng:'must be a string', jp:'文字列で入力してください'},
                                    ];
                                    const consistencyCheckList = [
                                        { id:'', eng:'existsFutureDataInEmpInfo is true', jp:'フォーマット出力日以降に適用開始日が存在するため必須です'},
                                        { id:'invalid', eng:'invalid', jp:'存在しないデータです'},
                                    ];
                                    let errorMessage;
                                    result.responseData.data.error.payload.forEach((e)=>{
                                        let rowNum = Number(e.split('.')[1]);
                                        let itemName = CFArrayFount(itemNameList,'id',e.split('.')[2].split(':')[0]).name;
                                        /* payload1 フォーマット/バリデーションでエラー */
                                        if(e.split('.')[0] === 'payload1'){
                                            let validation = validationList.find(element =>e.match(new RegExp(element.eng)));
                                            let thisError;
                                            if(validation?.id){
                                                switch(validation.id){
                                                    case'number'://桁数エラー
                                                        const charactersNum = new RegExp(validation.eng).exec(e)[1];
                                                        thisError = `${rowNum}行目の${itemName}は、${charactersNum}${validation.jp}。`;
                                                    break;
                                                    case'numberBetween'://桁数幅エラー
                                                        const hitData = new RegExp(validation.eng).exec(e);
                                                        const charactersNum1 = hitData[1];
                                                        const charactersNum2 = hitData[2];
                                                        thisError = `${rowNum}行目の${itemName}は、${charactersNum1}-${charactersNum2}${validation.jp}。`;
                                                    break;
                                                    default:
                                                        thisError = `${rowNum}行目の${itemName}は、${validation?.jp}。`
                                                    break;
                                            }}else{
                                                //フォーマットエラー
                                                thisError =`フォーマットエラー`;
                                            }
                                            errorMessage = errorMessage ? errorMessage + `\n${thisError}`: thisError;
                                        }
                                        /* payload2 整合性チェックでエラー */
                                        else{
                                            let consistency = consistencyCheckList.find(element =>e.match(new RegExp(element.eng)));
                                            let thisError = `${rowNum}行目の${itemName}は、${consistency?.jp ? consistency.jp:''}。`
                                            errorMessage = errorMessage ? errorMessage + `\n${thisError}`: thisError;
                                        };

                                    });
                                    /* OKボタン押下後の処理 */
                                    const afterFunc = () =>{
                                    };
                                    /* 確認ダイアログ表示 */
                                    setDialogMessage({
                                        ...dialogMessage,
                                        open:true, 
                                        message:errorMessage,//メッセージID(commonFunctionより対象のメッセージ)
                                        type:'text',
                                        afterFunc:afterFunc,
                                        pattern: 1//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                                    });
                                }else {//不正なリクエストキー
                                    /* スナックバー表示 */
                                    setSnackbarMessage({
                                        ...snackbarMessage,
                                        open:true,
                                        message:result,//APIによるエラー
                                        type: 1,//APIエラー時:1,それ以外:2
                                        level:'error',//エラースナックバー
                                    });
                                };
                            };
                        });
                    }else{ //①APIリクエスト結果 = 異常
                        document.getElementById('fileUpload').value = ''
                        /* プログレスバー非表示 */
                        setProgress(false);
                        /* エラーメッセージを表示 */
                        setSnackbarMessage({   //スナックバー表示   
                            ...snackbarMessage,
                            open:true,
                            message: uploadResut,//APIによるエラー
                            type: 1,//APIエラー時:1,それ以外:2 
                            level:'error',//エラースナックバー
                        });
                    };
                });
            }else{//APIリクエスト結果 = 異常
                document.getElementById('fileUpload').value = ''
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
                return;
            };
        });



    }
    /* ===テーブル内の編集アイコンボタンを押した時の処理=== */
    const onClickEditMove = (row, newData, oldData, type) => {
        navigate('/master/department/update',{state:{row:row, new: newData, old: oldData, type: type}})//データを遷移先へ渡す
    }

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:['otpDate'],
        payload: 
        {
            name:'dptMstInfo', 
            list:[
                {name:'aplySrtDate',                  base64:false},
                {name:'otpDate',                      base64:false},
                {name:'dptList',          
                    list:[
                        {name:'dptCd',                                            base64:false},
                        {name:'dptHqName',                                        base64:true},
                        {name:'dptHqEngName',                                     base64:false},
                        {name:'dptHqOrd',                                         base64:false},
                        {name:'dptPartName',                                      base64:true},
                        {name:'dptPartEngName',                                   base64:false},
                        {name:'dptPartOrd',                                       base64:false},
                        {name:'dptRomName',                                       base64:true},
                        {name:'dptRomEngName',                                    base64:false},
                        {name:'dptRomOrd',                                        base64:false},
                        {name:'dptGpName',                                        base64:true},
                        {name:'dptGpEngName',                                     base64:false},
                        {name:'dptGpOrd',                                         base64:false},
                        {name:'dptAbrName',                                       base64:true},
                        {name:'upperDptCd',                                       base64:false},
                        {name:'dptLevel',                                         base64:false},
                        {name:'lboCstClasfCd',                                    base64:false},
                        {name:'projSgmtCd',          name2:'projSgmtName',        base64:false,base642:true},// 後でbase642trueにする
                        {name:'partWithinCmmKbjCd',                               base64:false},
                        {name:'salesMnaExpePjCd',                                 base64:false},
                        {name:'lboCstPjCd',                                       base64:false},
                        {name:'mnaEmpNmb',           name2:'mnaEmpFullName',      base64:false,base642:true},
                        // {          base64:true},
                        {name:'postName',                                         base64:true},
                        {name:'dptChangeCont',                                    base64:true}
                    ]
                }
            ]
        }   
    };
	/*------ 更新データの設定 ------*/
    const updateConfig = {
        key:['aplySrtDate'],
        payload:[
            {name:'dptCd',                                            type:String,    base64: false},
            {name:'dptHqName',                                        type:String,    base64: true},
            {name:'dptHqEngName',                                     type:String,    base64: false},
            {name:'dptHqOrd',                                         type:String,    base64: false},
            {name:'dptPartName',                                      type:String,    base64: true},
            {name:'dptPartEngName',                                   type:String,    base64: false},
            {name:'dptPartOrd',                                       type:String,    base64: false},
            {name:'dptRomName',                                       type:String,    base64: true},
            {name:'dptRomEngName',                                    type:String,    base64: false},
            {name:'dptRomOrd',                                        type:String,    base64: false},
            {name:'dptGpName',                                        type:String,    base64: true},
            {name:'dptGpEngName',                                     type:String,    base64: false},
            {name:'dptGpOrd',                                         type:String,    base64: false},
            {name:'dptAbrName',                                       type:String,    base64: true},
            {name:'upperDptCd',                                       type:String,    base64: false},
            {name:'dptLevel',                                         type:String,    base64: false},
            {name:'lboCstClasfCd',                                    type:String,    base64: false},
            {name:'projSgmtCd',          name2:'projSgmtName',        type:String,    base64: false,base642:true},
            {name:'partWithinCmmKbjCd',                               type:String,    base64: false,base642:true},
            {name:'salesMnaExpePjCd',                                 type:String,    base64: false},
            {name:'lboCstPjCd',                                       type:String,    base64: false},
            {name:'mnaEmpNmb',           name2:'mnaEmpFullName',      type:String,    base64: false,base642:true},
            {name:'dptChangeCont',                                    type:String,    base64: true},
        ]              
    }
	/*------ 検索項目の設定 ------*/
    const searchConfig = {
        payload:[
            {name: 'dptCd'},
            {name: 'dptHqName'},
            {name: 'dptHqEngName'},
            {name: 'dptPartName'},
            {name: 'dptPartEngName'},
            {name: 'dptRomName'},
            {name: 'dptRomEngName'},
            {name: 'dptGpName'},
            {name: 'dptGpEngName'},
            {name: 'dptAbrName'},
            {name: 'dptLevel'},
            {name: 'lboCstClasfCd', master: 'laborCostClassificationMaster'},
            {name: 'upperDptCd'},
            {name: 'projSgmtCd'},
            {name: 'partWithinCmmKbjCd'},
            {name: 'salesMnaExpePjCd'},
            {name: 'lboCstPjCd'},
            {name: 'mnaEmpNmb'},
            {name: 'dptChangeCont'},
        ]
    }
    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'dptCd', align: 'left', width: '140px', label1: '部署コード' ,fixed:true,left:'0px', borderRight: '1px solid #c0c0c0'},//部署コード
    	{ id: 'dptHqName', align: 'left', width: '300px', label1:'本部名'},//本部
    	{ id: 'dptPartName', align: 'left', width: '300px', label1: '部名' },//部
        { id: 'dptRomName', align: 'left', width: '300px', label1: '室名' },//室
        { id: 'dptGpName', align: 'left', width: '300px', label1: 'G名' },//G
    	{ id: 'dptHqOrd', align: 'left', width: '100px', label1:'本部順'},//本部
    	{ id: 'dptPartOrd', align: 'left', width: '100px', label1:'部順'},//部
    	{ id: 'dptRomOrd', align: 'left', width: '100px', label1:'室順'},//室
    	{ id: 'dptGpOrd', align: 'left', width: '100px', label1:'G順'},//G
    	{ id: 'dptHqEngName', align: 'left', width: '300px', label1:'本部英名'},//本部
    	{ id: 'dptPartEngName', align: 'left', width: '300px', label1:'部英名'},//部
    	{ id: 'dptRomEngName', align: 'left', width: '300px', label1:'室英名'},//室
    	{ id: 'dptGpEngName', align: 'left', width: '300px', label1:'G英名'},//G
        { id: 'dptAbrName', align: 'left', width: '300px', label1: '部署略名' },//部署略名
        { id: 'upperDptCd', align: 'left', width: '300px', label1: '上位部署コード' },//上位部署コード
        { id: 'dptLevel', align: 'left', width: '100px', label1: '部署レベル' },//部署レベル
        { id: 'lboCstClasfCd', align: 'left', width: '100px', label1: '人件費区分' },//人件費区分
        { id: 'projSgmtCd', align: 'left', width: '200px', label1: '事業セグメント' },//事業セグメント
        { id: 'partWithinCmmKbjCd', align: 'left', width: '300px', label1: '部内共通(KBJ)コード' },//部内共通(KBJ)コード
        { id: 'salesMnaExpePjCd', align: 'left', width: '300px', label1: '販管費PJコード' },//販管費PJコード
        { id: 'lboCstPjCd', align: 'left', width: '300px', label1: '人件費PJコード' },//人件費PJコード
        { id: 'mnaEmpNmb',align: 'left', width: '300px', label1: '所属長'},//所属長
        { id: 'postName', align: 'left', width: '150px', label1: '役職' },//役職
        { id: 'dptChangeCont', align: 'left', width: '200px', label1: '部署変更内容' },//変更内容

    ];
    const headEditData = [
    	{ id: 'deleteIcon', align: 'center', width: '50px',label1: '削除',fixed:true,left:'0px'},//〇〇データ
    	{ id: 'editIcon', align: 'center', width: '50px',label1: '編集',fixed:true,left:'56px'},//〇〇データ
    	{ id: 'dptCd', align: 'left', width: '140px', label1: '部署コード' ,fixed:true,left:'112px', borderRight: '1px solid #c0c0c0'},//部署コード
        ...headData.slice(1)
    ]
    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton

    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'dptCd', type: 'label',  align: 'left',fixed:true,left:'0px',borderRight: '1px solid #c0c0c0'},
        { name: 'dptHqName', type: 'label',  align: 'left'},
        { name: 'dptPartName', type: 'label',  align: 'left'},
        { name: 'dptRomName', type: 'label',  align: 'left'},
        { name: 'dptGpName', type: 'label',  align: 'left'},
        { name: 'dptHqOrd', type: 'label',  align: 'left'},
        { name: 'dptPartOrd', type: 'label',  align: 'left'},
        { name: 'dptRomOrd', type: 'label',  align: 'left'},
        { name: 'dptGpOrd', type: 'label',  align: 'left'},
        { name: 'dptHqEngName', type: 'label',  align: 'left'},
        { name: 'dptPartEngName', type: 'label',  align: 'left'},
        { name: 'dptRomEngName', type: 'label',  align: 'left'},
        { name: 'dptGpEngName', type: 'label',  align: 'left'},
        { name: 'dptAbrName', type: 'label',  align: 'left'},
        { name: 'upperDptCd', type: 'label',  align: 'left'},
        { name: 'dptLevel', type: 'label',  align: 'left'},
        { name: 'lboCstClasfCd', type: 'edit',  align: 'left', masterType: 'master', master: 'laborCostClassificationMaster'},
        { name: 'projSgmtCd',name2:'projSgmtName', type: 'label',  align: 'left'}, 
        { name: 'partWithinCmmKbjCd', type: 'label',  align: 'left'},
        { name: 'salesMnaExpePjCd', type: 'label',  align: 'left'},
        { name: 'lboCstPjCd', type: 'label',  align: 'left'},
        { name: 'mnaEmpNmb',name2:'mnaEmpFullName', type: 'label',  align: 'left'},
        { name: 'postName', type: 'label',  align: 'left'},
        { name: 'dptChangeCont', type: 'label',  align: 'left'},
    ];
    const editBodyData = [
        { name: 'deleteIcon', type: 'deleteIcon',  align: 'center',fixed:true,left:'0px'},
        { name: 'editIcon', type: 'editIcon',func:onClickEditMove, align: 'center',fixed:true,left:'56px'},
        { name: 'dptCd', type: 'label',  align: 'left',fixed:true,left:'113px',   borderRight: '1px solid #c0c0c0'},
        { name: 'dptHqName', type: 'label',  align: 'left', },
        { name: 'dptPartName', type: 'label',  align: 'left', },
        { name: 'dptRomName', type: 'label',  align: 'left', },
        { name: 'dptGpName', type: 'label',  align: 'left', },
        { name: 'dptHqOrd', type: 'label',  align: 'left'},
        { name: 'dptPartOrd', type: 'label',  align: 'left'},
        { name: 'dptRomOrd', type: 'label',  align: 'left'},
        { name: 'dptGpOrd', type: 'label',  align: 'left'},
        { name: 'dptHqEngName', type: 'label',  align: 'left',  },
        { name: 'dptPartEngName', type: 'label',  align: 'left',  },
        { name: 'dptRomEngName', type: 'label',  align: 'left', },
        { name: 'dptGpEngName', type: 'label',  align: 'left',},
        { name: 'dptAbrName', type: 'label',  align: 'left',},
        { name: 'upperDptCd', type: 'label', align: 'left',},
        { name: 'dptLevel', type: 'label',  align: 'left', },
        { name: 'lboCstClasfCd', type: 'edit',  align: 'left', masterType: 'master', master: 'laborCostClassificationMaster'},
        { name: 'projSgmtCd',name2:'projSgmtName', type: 'label',  align: 'left'},
        { name: 'partWithinCmmKbjCd', type: 'label',  align: 'left'},
        { name: 'salesMnaExpePjCd', type: 'label',  align: 'left', },
        { name: 'lboCstPjCd', type: 'label',  align: 'left',},
        { name: 'mnaEmpNmb',name2:'mnaEmpFullName', type: 'label',  align: 'left',},
        { name: 'postName', type: 'label', align: 'left'},
        { name: 'dptChangeCont', type: 'label',  align: 'left',},
    ];

    /* ======== ページヘッダーの設定 ======== */
    /*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索欄(左)を定義 ====== */
    const searchContentsLeft = [
        {id:'sarLiteral',type:'input', maxLength: 50,name:'検索文字',placeholder:'',width:'280px', pattern:'keyword'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];

    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
        {id:'formatDownload',type:'formatDownloadButton', path: '/master/department/format'},
        {id:'resister',type:'resisterButton',func:onClickFormat},
    ];

    /* ====== 検索初期値を定義 ====== */
    const defaultSearch = {
        sarLiteral:'',
    }

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
			<MasterTemp
				listType='deptMaster'//一覧タイプ(master:　編集ありの通常のマスタ、noneEdit:編集なし)
                listMode='noneListEdit'
                initialSearch={true}//初期検索有無
                searchCount={true}//検索件数表示
				pageTitle='部署マスタ'//画面タイトル
                searchContentsLeft={searchContentsLeft}//検索欄左設定
				searchContentsRight={searchContentsRight}//検索欄右設定
				apiPath='/master/getlistdepartment' //一覧取得のApiPath
				updateApiPath='/master/updatedepartment'//一覧取得のApiPath
				headData={headData}//テーブルヘッダ設定
                editHeadData={headEditData}
				bodyData={bodyData}//テーブルボディ設定
                editBodyData={editBodyData}
                showEffectiveDate={true}
                subPageTitle='部署マスタ情報'
				getConfig={getConfig}//テーブル取得設定
                disableList={['dptCd']}
                searchConfig={searchConfig}
                path={{next: '/master/department/confirm', now: '/master/department/list',deleteConfirm:'/master/department/delete'}}
                changeOrder={true}
                updateConfig={updateConfig}
                onClickRegister={onClickResister}
                masterList={['laborCostClassificationMaster']}
                defaultSearch={defaultSearch}
			/>
            <input 
                id='fileUpload' 
                type='file' 
                accept=".xlsx" 
                hidden 
                onChange={(event) => handleFileSelect(event)}
            />
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/>
        </>
    );



};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 